import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../assets/logo.png";

export default function Payment() {
  const navigate = useNavigate();
  const location = useLocation();
  const [plan] = useState(location.state?.plan || "FREE");
  const [paymentMethod, setPaymentMethod] = useState("credit_card");
  const [formData, setFormData] = useState({
    cardNumber: "",
    cardName: "",
    expiryDate: "",
    cvv: "",
    installments: 1,
  });

  const plans = {
    FREE: { name: "Gratuito", price: 0, description: "1 Contrato" },
    BASIC: { name: "Básico", price: 49.90, description: "Até 10 Contratos" },
    PROFESSIONAL: { name: "Profissional", price: 119.90, description: "Até 30 Contratos" },
    CONDOMINIUM: { name: "Condomínio", price: 5, description: "Por unidade/mês" },
  };

  const currentPlan = plans[plan] || plans.FREE;

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Aqui você integraria com o gateway de pagamento
    // Por enquanto, apenas redireciona para o portfolio
    navigate("/portfolio");
  };

  const formatCardNumber = (value) => {
    const v = value.replace(/\s+/g, "").replace(/[^0-9]/gi, "");
    const matches = v.match(/\d{4,16}/g);
    const match = (matches && matches[0]) || "";
    const parts = [];
    for (let i = 0, len = match.length; i < len; i += 4) {
      parts.push(match.substring(i, i + 4));
    }
    if (parts.length) {
      return parts.join(" ");
    } else {
      return v;
    }
  };

  const handleCardNumberChange = (e) => {
    const formatted = formatCardNumber(e.target.value);
    setFormData({ ...formData, cardNumber: formatted });
  };

  return (
    <div className="container" style={{ maxWidth: "800px", margin: "4rem auto" }}>
      <div className="panel" style={{ padding: "3rem" }}>
        <div style={{ textAlign: "center", marginBottom: "2rem" }}>
          <img
            src={logo}
            alt="Sistema Único - Imobiliárias"
            style={{ width: "450px", height: "auto", marginBottom: "1.5rem" }}
          />
          <h1 style={{ marginBottom: "0.5rem" }}>Finalizar Assinatura</h1>
          <p style={{ color: "var(--text-secondary)" }}>
            Complete seu cadastro e comece a usar o Sistema Único - Imobiliárias
          </p>
        </div>

        <div style={{ 
          background: "linear-gradient(135deg, rgba(0, 86, 179, 0.1) 0%, rgba(34, 139, 34, 0.1) 100%)",
          padding: "1.5rem",
          borderRadius: "var(--radius-lg)",
          marginBottom: "2rem",
          border: "1px solid rgba(0, 86, 179, 0.2)"
        }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <h3 style={{ margin: 0, marginBottom: "0.5rem" }}>Plano Selecionado</h3>
              <p style={{ margin: 0, color: "var(--text-secondary)" }}>{currentPlan.description}</p>
            </div>
            <div style={{ textAlign: "right" }}>
              <div style={{ fontSize: "2rem", fontWeight: 700, color: "var(--brand-blue)" }}>
                {currentPlan.price === 0 ? "Grátis" : `R$ ${currentPlan.price.toFixed(2)}`}
              </div>
              {currentPlan.price > 0 && (
                <p style={{ margin: 0, color: "var(--text-secondary)", fontSize: "0.9rem" }}>
                  {plan === "CONDOMINIUM" ? "por unidade/mês" : "por mês"}
                </p>
              )}
            </div>
          </div>
        </div>

        {currentPlan.price === 0 ? (
          <div style={{ textAlign: "center" }}>
            <p style={{ color: "var(--text-secondary)", marginBottom: "1.5rem" }}>
              Seu plano gratuito está ativo! Você pode começar a usar o sistema agora.
            </p>
            <button
              className="btn-primary"
              onClick={() => navigate("/portfolio")}
              style={{ width: "100%" }}
            >
              Começar a Usar
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: "1.5rem" }}>
              <label style={{ display: "block", marginBottom: "0.5rem", fontWeight: 500 }}>
                Método de Pagamento
              </label>
              <div style={{ display: "flex", gap: "1rem" }}>
                <label style={{ 
                  flex: 1, 
                  padding: "1rem", 
                  border: paymentMethod === "credit_card" ? "2px solid var(--brand-blue)" : "1px solid var(--border)",
                  borderRadius: "var(--radius-md)",
                  cursor: "pointer",
                  textAlign: "center"
                }}>
                  <input
                    type="radio"
                    name="paymentMethod"
                    value="credit_card"
                    checked={paymentMethod === "credit_card"}
                    onChange={(e) => setPaymentMethod(e.target.value)}
                    style={{ marginRight: "0.5rem" }}
                  />
                  💳 Cartão de Crédito
                </label>
                <label style={{ 
                  flex: 1, 
                  padding: "1rem", 
                  border: paymentMethod === "pix" ? "2px solid var(--brand-blue)" : "1px solid var(--border)",
                  borderRadius: "var(--radius-md)",
                  cursor: "pointer",
                  textAlign: "center"
                }}>
                  <input
                    type="radio"
                    name="paymentMethod"
                    value="pix"
                    checked={paymentMethod === "pix"}
                    onChange={(e) => setPaymentMethod(e.target.value)}
                    style={{ marginRight: "0.5rem" }}
                  />
                  📱 PIX
                </label>
              </div>
            </div>

            {paymentMethod === "credit_card" && (
              <>
                <div style={{ marginBottom: "1.5rem" }}>
                  <label htmlFor="cardNumber" style={{ display: "block", marginBottom: "0.5rem", fontWeight: 500 }}>
                    Número do Cartão
                  </label>
                  <input
                    id="cardNumber"
                    name="cardNumber"
                    type="text"
                    value={formData.cardNumber}
                    onChange={handleCardNumberChange}
                    maxLength="19"
                    placeholder="0000 0000 0000 0000"
                    required
                    style={{
                      width: "100%",
                      padding: "0.75rem",
                      border: "1px solid var(--border)",
                      borderRadius: "var(--radius-md)",
                      fontSize: "1rem",
                    }}
                  />
                </div>

                <div style={{ marginBottom: "1.5rem" }}>
                  <label htmlFor="cardName" style={{ display: "block", marginBottom: "0.5rem", fontWeight: 500 }}>
                    Nome no Cartão
                  </label>
                  <input
                    id="cardName"
                    name="cardName"
                    type="text"
                    value={formData.cardName}
                    onChange={handleChange}
                    placeholder="NOME COMPLETO"
                    required
                    style={{
                      width: "100%",
                      padding: "0.75rem",
                      border: "1px solid var(--border)",
                      borderRadius: "var(--radius-md)",
                      fontSize: "1rem",
                    }}
                  />
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr", gap: "1rem", marginBottom: "1.5rem" }}>
                  <div>
                    <label htmlFor="expiryDate" style={{ display: "block", marginBottom: "0.5rem", fontWeight: 500 }}>
                      Validade
                    </label>
                    <input
                      id="expiryDate"
                      name="expiryDate"
                      type="text"
                      value={formData.expiryDate}
                      onChange={handleChange}
                      placeholder="MM/AA"
                      maxLength="5"
                      required
                      style={{
                        width: "100%",
                        padding: "0.75rem",
                        border: "1px solid var(--border)",
                        borderRadius: "var(--radius-md)",
                        fontSize: "1rem",
                      }}
                    />
                  </div>
                  <div>
                    <label htmlFor="cvv" style={{ display: "block", marginBottom: "0.5rem", fontWeight: 500 }}>
                      CVV
                    </label>
                    <input
                      id="cvv"
                      name="cvv"
                      type="text"
                      value={formData.cvv}
                      onChange={handleChange}
                      placeholder="123"
                      maxLength="4"
                      required
                      style={{
                        width: "100%",
                        padding: "0.75rem",
                        border: "1px solid var(--border)",
                        borderRadius: "var(--radius-md)",
                        fontSize: "1rem",
                      }}
                    />
                  </div>
                  <div>
                    <label htmlFor="installments" style={{ display: "block", marginBottom: "0.5rem", fontWeight: 500 }}>
                      Parcelas
                    </label>
                    <select
                      id="installments"
                      name="installments"
                      value={formData.installments}
                      onChange={handleChange}
                      style={{
                        width: "100%",
                        padding: "0.75rem",
                        border: "1px solid var(--border)",
                        borderRadius: "var(--radius-md)",
                        fontSize: "1rem",
                      }}
                    >
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((num) => (
                        <option key={num} value={num}>
                          {num}x
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </>
            )}

            {paymentMethod === "pix" && (
              <div style={{ 
                padding: "1.5rem", 
                background: "var(--border-light)", 
                borderRadius: "var(--radius-md)",
                textAlign: "center"
              }}>
                <p style={{ color: "var(--text-secondary)", marginBottom: "1rem" }}>
                  Após confirmar, você receberá o QR Code do PIX para pagamento
                </p>
              </div>
            )}

            <button
              type="submit"
              className="btn-primary"
              style={{ width: "100%", marginTop: "1.5rem", fontSize: "1.1rem", padding: "1rem" }}
            >
              {paymentMethod === "pix" ? "Gerar QR Code PIX" : "Confirmar Pagamento"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
